<template>
  <div class="contract-stock-dialog">
    <el-dialog v-drag-dialog :title="model.title" :visible.sync="visible" :before-close="closeDialog" :close-on-click-modal="false" width="800px">
      <div class="dialog-body">
        <!-- 表单 -->
        <el-form :model="form" ref="form">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('crm_contract_stock_dialog.sbywlx')" prop="deviceBizType" :rules="rules.deviceBizType">
                <custom-select v-model="form.deviceBizType" code="dms_device_biz_type" :placeholder="$t('Common.com_please_select')"></custom-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('crm_contract_stock_dialog.fang_an_bian_ma')" prop="ruleCode" :rules="rules.ruleCode">
                <el-input placeholder="" v-model="form.ruleCode"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('crm_contract_stock_dialog.chan_pin_xing_hao')" prop="productCode" :rules="rules.productCode">
                <el-select v-model="form.productCode" :placeholder="$t('Common.com_please_select')">
                  <el-option v-for="item in modelList" :key="item.productCode" :label="item.productCode" :value="item.productCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('crm_contract_stock_dialog.ban_ben_hao')" prop="version" :rules="rules.version">
                <el-input placeholder="" v-model="form.version"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-row>
                <el-col :span="24">
                  <el-row>
                    <el-col :span="18">
                      <el-form-item :label="$t('crm_contract_stock_dialog.mei_yue_guan_li_fei')" prop="stockCost" :rules="rules.stockCost">
                        <el-input type="number" :placeholder="$t('Common.com_please_input')" v-model="form.stockCost"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="` `" prop="currencyUnit" :rules="rules.currencyUnit" class="unit">
                        <custom-select v-model="form.currencyUnit" code="isynergy_cloud_currency" :placeholder="$t('Common.com_please_select')"></custom-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row>
                <el-col :span="24">
                  <el-row>
                    <el-col :span="18">
                      <el-form-item :label="$t('crm_contract_stock_dialog.mian_fei_shi_chang')" prop="freeDuration" :rules="rules.freeDuration">
                        <el-input type="number" :placeholder="$t('Common.com_please_input')" v-model="form.freeDuration"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="` `" prop="freeUnit" :rules="rules.freeUnit" class="unit">
                        <custom-select v-model="form.freeUnit" code="crm_sharing_rule_free_unit" :placeholder="$t('Common.com_please_select')"></custom-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="20" style="margin: 8px 0; padding: 16px 12px; border: 1px solid #dedede">
            <el-form-item :label="$t('crm_contract_stock_dialog.zhi_xing_tiao_jian')" prop="connectSymbol" :rules="rules.connectSymbol">
              <el-radio-group v-model="form.connectSymbol" style="padding: 0 8px">
                <el-radio :label="0">{{ $t('crm_contract_stock_dialog.ren_yi_tiao_jian') }}</el-radio>
                <el-radio :label="1">{{ $t('crm_contract_stock_dialog.suo_you_tiao_jian') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <div class="ub" style="padding: 0 8px; margin-bottom: 12px" v-for="(item, index) in ruleConditionList" :key="index">
              <div class="ub-f2" style="margin-right: 12px">
                <custom-select code="crm_stock_rule_condition_type" v-model="item.type" width="100%"></custom-select>
              </div>
              <div class="ub-f1" style="margin-right: 12px">
                <custom-select code="isynergy_cloud_symbol" v-model="item.symbol" width="100%"></custom-select>
              </div>
              <div class="ub-f2" style="margin-right: 12px">
                <el-input type="number" v-model="item.value" style="width: 100%"></el-input>
              </div>
              <el-button v-if="index == 0" type="primary" @click="addSymbol(ruleConditionList)">
                <i class="icon icon-add"></i>
                {{ $t('Common.com_added') }}
              </el-button>
              <el-button v-else type="warning" @click="delSymbol(ruleConditionList, index)">
                <i class="icon icon-shanchu"></i>
                {{ $t('Common.com_delete') }}
              </el-button>
            </div>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item :label="$t('crm_contract_stock_dialog.bei_zhu')" prop="ruleDesc" :rules="rules.ruleDesc">
                <el-input rows="3" type="textarea" :placeholder="$t('Common.com_please_input')" v-model="form.ruleDesc"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  props: {
    data: [String, Object, Array],
  },
  data() {
    return {
      modelList: [],
      ruleConditionList: [
        {
          type: '',
          symbol: '',
          value: '',
        },
      ],
      form: {
        stockRuleId: '',
        deviceBizType: '',
        currencyUnit: '¥',
        productCode: '',
        freeDuration: '',
        freeUnit: '',
        ruleCondition: '', // 规则
        connectSymbol: 0, // 条件
        ruleCode: '',
        ruleDesc: '',
        stockCost: '',
        version: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        ruleDesc: [{ max: 200, message: this.$t('Common.com_rules_length_max', [200]), }],
        deviceBizType: [{ required: true, message: this.$t('crm_contract_stock_dialog.qxzsbywlx') }],
        ruleCode: [
          { required: true, message: this.$t('crm_contract_stock_dialog.qtxfabm') },
          { max: 30, message: this.$t('Common.com_rules_length_max', [30]), },
        ],
        productCode: [{ required: true, message: this.$t('crm_contract_stock_dialog.qxzcpxh') }],
        version: [
          { required: true, message: this.$t('crm_contract_stock_dialog.qtxbbh') },
          { max: 30, message: this.$t('Common.com_rules_length_max', [30]), },
        ],
        stockCost: [{ required: true, message: this.$t('crm_contract_stock_dialog.qtxmyglf') }],
        freeDuration: [{ required: true, message: this.$t('crm_contract_stock_dialog.qtxmfts') }],
        freeUnit: [{ required: true, message: this.$t('crm_contract_stock_dialog.qxzmfdw') }],
        currencyUnit: [{ required: true, message: this.$t('crm_contract_stock_dialog.qxzhbdw') }],
      };
    },
  },
  mounted() {
    this.initDialog();
    this.getModelList();
  },
  methods: {
    // 添加条件
    addSymbol: function (item) {
      item.push({ type: '', symbol: '', value: '' });
    },
    // 删除条件
    delSymbol: function (item, index) {
      item.splice(index, 1);
    },
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      if (this.model.type === 'edit') {
        this.$setFormatData(this.form, this.data.item);
        this.form.connectSymbol = this.form.ruleCondition.includes('||') ? 0 : 1;
        const str = this.form.ruleCondition.replace(/^\(|\)$|\s/g, '');
        const strList = str.split(this.form.connectSymbol ? '&' : '||');
        const reg = /^(\w+)([^\d]+)(\d*)/;
        this.ruleConditionList = strList.map((t) => {
          const arr = t.match(reg) || [];
          return { type: arr[1] || '', symbol: arr[2] || '', value: arr[3] || '' };
        });
      }
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    // 产品型号列表
    getModelList: function () {
      this.$getJSON(apis.productCodeSelectList).then((res) => {
        if (res.code === 0) {
          this.modelList = res.data;
        }
      });
    },
    // 确认保存
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.model.type === 'add') {
          this.saveInsert();
        }
        if (this.model.type === 'edit') {
          this.saveUpdate();
        }
      });
    },
    // 保存新增
    saveInsert: function () {
      const list = this.ruleConditionList.filter((t) => t.type && t.symbol && t.value);
      if (list.length) {
        this.form.ruleCondition = `(${list.map((t) => `${t.type}${t.symbol}${t.value}`).join(this.form.connectSymbol ? '&' : '||')})`;
      } else {
        this.form.ruleCondition = '';
      }
      this.$postJSON(apis.stockCostSchemeAdd, this.form).then(() => {
        this.$message({
          message: this.$t('crm_contract_stock_dialog.xzkcffacg'),
          type: 'success',
        });
        this.$emit('success');
        this.closeDialog();
      });
    },
    // 保存编辑
    saveUpdate: function () {
      const list = this.ruleConditionList.filter((t) => t.type && t.symbol && t.value);
      if (list.length) {
        this.form.ruleCondition = `(${list.map((t) => `${t.type}${t.symbol}${t.value}`).join(this.form.connectSymbol ? '&' : '||')})`;
      } else {
        this.form.ruleCondition = '';
      }
      this.$postJSON(apis.stockCostSchemeUpdate, this.form).then(() => {
        this.$message({
          message: this.$t('crm_contract_stock_dialog.bjkcffacg'),
          type: 'success',
        });
        this.$emit('success', this.form);
        this.closeDialog();
      });
    },
  },
};
</script>

<style lang="scss">
.contract-stock-dialog {
  .unit {
    .el-form-item__label {
      opacity: 0;
    }
  }
}
</style>
